import { render, staticRenderFns } from "./LocalInfoPreview.vue?vue&type=template&id=74178617"
import script from "./LocalInfoPreview.vue?vue&type=script&lang=js"
export * from "./LocalInfoPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports